const initialChatInformationState = {
  filterInternalIds: [],
  filterClientIds: [],
  sortInternal: '',
  sortClient: '',
};

export { initialChatInformationState };
